'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disablePageScroll = disablePageScroll;
exports.enablePageScroll = enablePageScroll;
// Disables scrolling on the page
function disablePageScroll() {
  // Don't change the styles if there is already a modal showing
  if (window.document.body.style.overflowY === 'hidden') {
    return;
  }

  Object.assign(window.document.body.style, {
    overflowY: 'hidden'
  });
}

// Enable scrolling on the page
function enablePageScroll() {
  Object.assign(window.document.body.style, {
    overflowY: ''
  });
}